let currentLanguage: "zh" | "en" = detectSystemLanguage(); // 初始化语言为系统语言

// 自动检测系统语言
function detectSystemLanguage(): "zh" | "en" {
  const language = navigator.language; // 使用正确的 navigator.language
  return language.startsWith("zh") ? "zh" : "en";
}

// 设置语言
export function setLanguage(lang: "zh" | "en"): void {
  currentLanguage = lang;
}
const errorMessages: { [key: number]: { [key: string]: string } } = {
    400: { zh: "请求无效，请检查输入。", en: "Bad request. Please check your input." },
    401: { zh: "未授权访问，请登录后重试。", en: "Unauthorized access. Please log in and try again." },
    402: { zh: "支付请求失败，请检查付款信息。", en: "Payment required. Please check your payment details." },
    403: { zh: "您没有权限执行此操作。", en: "Forbidden. You do not have permission to perform this action." },
    404: { zh: "请求的资源不存在。", en: "Resource not found." },
    405: { zh: "请求方法不允许，请检查请求方式。", en: "Method not allowed. Please check the request method." },
    406: { zh: "请求的内容不可接受，请更改请求。", en: "Not acceptable. Please modify your request." },
    407: { zh: "需要代理身份验证，请验证您的代理设置。", en: "Proxy authentication required. Please authenticate your proxy." },
    408: { zh: "请求超时，请稍后再试。", en: "Request timeout. Please try again later." },
    409: { zh: "请求冲突，请检查数据一致性。", en: "Conflict. Please check for data consistency." },
    410: { zh: "请求的资源已永久删除。", en: "Gone. The resource is no longer available." },
    411: { zh: "需要指定内容长度，请添加长度信息。", en: "Length required. Please specify the content length." },
    412: { zh: "请求条件失败，请检查请求头信息。", en: "Precondition failed. Please check request headers." },
    413: { zh: "请求实体过大，服务器无法处理。", en: "Payload too large. The server cannot process this request." },
    414: { zh: "请求URI过长，服务器无法处理。", en: "URI too long. The server cannot process this request." },
    415: { zh: "不支持的媒体类型，请检查上传文件格式。", en: "Unsupported media type. Please check the file format." },
    416: { zh: "请求的范围不合法。", en: "Range not satisfiable." },
    417: { zh: "服务器无法满足预期的需求。", en: "Expectation failed." },
    418: { zh: "我是茶壶 (I'm a teapot)。", en: "I'm a teapot." },
    421: { zh: "请求被重定向到错误的服务器。", en: "Misdirected request. The request was directed to the wrong server." },
    422: { zh: "请求格式正确，但语义有误，无法响应。", en: "Unprocessable entity. The request was well-formed but unable to be followed." },
    423: { zh: "资源被锁定。", en: "Locked. The resource is currently locked." },
    424: { zh: "由于前一个请求失败，当前请求失败。", en: "Failed dependency. The request failed due to a previous request failure." },
    425: { zh: "服务器拒绝处理过早的请求，请稍后重试。", en: "Too early. Please try again later." },
    426: { zh: "需要升级协议，请使用更高版本的协议。", en: "Upgrade required. Please use a newer protocol." },
    428: { zh: "需要先决条件，请提供必需的请求信息。", en: "Precondition required. Please provide the required information." },
    429: { zh: "请求过于频繁，请稍后再试。", en: "Too many requests. Please try again later." },
    431: { zh: "请求头字段过大，服务器无法处理。", en: "Request header fields too large." },
    451: { zh: "由于法律原因，请求被拒绝。", en: "Unavailable for legal reasons." },
    500: { zh: "服务器内部错误，请稍后再试。", en: "Internal server error. Please try again later." },
    501: { zh: "服务器不具备处理请求的功能。", en: "Not implemented. The server does not support the requested functionality." },
    502: { zh: "网关错误，请稍后再试。", en: "Bad gateway. Please try again later." },
    503: { zh: "服务不可用，请稍后再试。", en: "Service unavailable. Please try again later." },
    504: { zh: "网关超时，请稍后再试。", en: "Gateway timeout. Please try again later." },
    505: { zh: "HTTP版本不支持，请检查协议版本。", en: "HTTP version not supported." },
    506: { zh: "服务器存在内部配置错误。", en: "Variant also negotiates. The server has an internal configuration error." },
    507: { zh: "服务器存储空间不足，无法完成请求。", en: "Insufficient storage. The server cannot store the representation." },
    508: { zh: "服务器检测到无限循环。", en: "Loop detected." },
    510: { zh: "未扩展，服务器缺少完成请求所需的扩展。", en: "Not extended. The server requires further extensions to fulfill the request." },
    511: { zh: "需要网络认证，请登录以访问网络资源。", en: "Network authentication required. Please log in to access network resources." },
  };
  

const defaultErrorMessages={
    zh:'发生错误，请稍后再试。',
    en:'An error occurred. Please try again later.'
}
export function getErrorMessage(statusCode: number): string {
  const messages = errorMessages[statusCode] ||defaultErrorMessages; // 默认中文
  const message = messages[currentLanguage];
  return message;
}
